<!-- ========================================
     HEADER DEL DASHBOARD
     ======================================== -->
<div class="container-fluid py-4">
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h2 class="mb-1">
            <i class="fas fa-cogs text-primary"></i>
            Administración de Pagos Asíncronos
          </h2>
          <p class="text-muted mb-0">Panel de control para verificación asíncrona de pagos</p>
        </div>
        
        <div class="d-flex gap-2">
          <!-- Botón Refresh -->
          <button 
            type="button" 
            class="btn btn-outline-primary"
            [disabled]="loading"
            (click)="refreshDashboard()">
            <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
            Actualizar
          </button>
          
          <!-- Perfil bancario (switch de contratos, separación 1-nov-2026): pantalla aparte -->
          <a data-rbac-permiso="config.perfil_bancario.read"
            *ngIf="_auth.hasPermission('config.perfil_bancario.read')"
            routerLink="/console/perfil-bancario"
            class="btn btn-outline-primary">
            <i class="fas fa-exchange-alt"></i>
            Perfil bancario
          </a>

          <!-- Botón Configuración -->
          <button data-rbac-permiso="config.pagos_async.config" 
            *ngIf="_auth.hasPermission('config.pagos_async.config')"
            type="button" 
            class="btn btn-primary"
            (click)="toggleConfigPanel()">
            <i class="fas fa-cog"></i>
            Configuración
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       ESTADO DE CARGA GENERAL
       ======================================== -->
  <div *ngIf="loading && !dashboardData" class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body text-center py-5">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <p class="mb-0">Cargando dashboard de administración...</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       ERROR STATE
       ======================================== -->
  <div *ngIf="error && !dashboardData" class="row">
    <div class="col-12">
      <div class="alert alert-danger" role="alert">
        <i class="fas fa-exclamation-triangle me-2"></i>
        {{ error }}
      </div>
    </div>
  </div>

  <!-- ========================================
       PANEL DE CONFIGURACIÓN (COLAPSABLE)
       ======================================== -->
  <div *ngIf="configPanelOpen && asyncConfig" class="row mb-4">
    <div class="col-12">
      <div class="card border-primary">
        <div class="card-header bg-primary text-white">
          <h5 class="mb-0">
            <i class="fas fa-cog me-2"></i>
            Configuración del Sistema Pagos y Verificación Asíncrona
          </h5>
        </div>
        <div class="card-body">
          <div class="row">
            <!-- Toggles Principales -->
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">Funcionalidades Principales</h6>
              
              <!-- Toggle Async -->
              <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
                <div>
                  Verificación Asíncrona
                  <br>
                  <small class="text-muted">Habilita el procesamiento asíncrono de pagos</small>
                </div>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="asyncToggle"
                    [checked]="asyncConfig.async_validation_active"
                    [disabled]="configLoading"
                    (change)="toggleAsyncFeature('async', asyncConfig.async_validation_active)">
                  <label class="form-check-label" for="asyncToggle"></label>
                </div>
              </div>

              <!-- Toggle BDV Auto-Conciliación -->
              <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
                <div>
                 Autoconciliación de pagos entrantes del  <strong>Banco de Venezuela</strong>
                  <br>
                  <small class="text-muted">Permite activar/desactivar la verificación automática de pagos del Banco de Venezuela, desde el evento de notificación automático enviado por el banco.</small>
                </div>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="bdvToggle"
                    [checked]="bdvConfig?.auto_conciliation"
                    [disabled]="configLoading"
                    (change)="toggleBDVAutoConciliation(bdvConfig?.auto_conciliation)">
                  <label class="form-check-label" for="bdvToggle"></label>
                </div>
              </div>
              
              <!-- Toggle Manual Fallback - OCULTO POR AHORA -->
              <!-- 
              <div class="d-flex justify-content-between align-items-center mb-3 p-3 border rounded">
                <div>
                  <strong>Fallback Manual</strong>
                  <br>
                  <small class="text-muted">Permite procesamiento manual cuando falla async</small>
                </div>
                <div class="form-check form-switch">
                  <input 
                    class="form-check-input" 
                    type="checkbox" 
                    id="fallbackToggle"
                    [checked]="asyncConfig.auto_manual_fallback_active"
                    [disabled]="configLoading"
                    (change)="toggleAsyncFeature('manual-fallback', asyncConfig.auto_manual_fallback_active)">
                  <label class="form-check-label" for="fallbackToggle"></label>
                </div>
              </div>
              -->
            </div>
            
            <!-- Configuración Numérica -->
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">Parámetros de Configuración</h6>
              
              <div class="row justify-content-center">
                <div class="col-md-6 mb-3">
                  <label for="maxAttempts" class="form-label">Máximo Intentos</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="maxAttempts"
                    [(ngModel)]="asyncConfig.async_max_attempts"
                    min="1" 
                    max="10"
                    [disabled]="configLoading">
                </div>
                
                <div class="col-md-6 mb-3">
                  <label for="attemptIncrement" class="form-label">Incremento (min)</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="attemptIncrement"
                    [(ngModel)]="asyncConfig.async_period_attempt_increment"
                    min="1"
                    [disabled]="configLoading">
                </div>
                
                <!-- CAMPOS OCULTOS POR AHORA -->
                <!-- 
                <div class="col-6 mb-3">
                  <label for="manualThreshold" class="form-label">Umbral Manual</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="manualThreshold"
                    [(ngModel)]="asyncConfig.async_manual_attempt_threshold"
                    min="1"
                    [disabled]="configLoading">
                </div>
                
                <div class="col-6 mb-3">
                  <label for="lotesAttemps" class="form-label">Lotes Intentos</label>
                  <input 
                    type="number" 
                    class="form-control" 
                    id="lotesAttemps"
                    [(ngModel)]="asyncConfig.async_lotes_attemps"
                    min="1"
                    [disabled]="configLoading">
                </div>
                -->
              </div>
            </div>
          </div>
          
          <!-- Botones de Acción -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="d-flex justify-content-end gap-2">
                <button 
                  type="button" 
                  class="btn btn-secondary"
                  (click)="configPanelOpen = false"
                  [disabled]="configLoading">
                  Cancelar
                </button>
                <button 
                  type="button" 
                  class="btn btn-success"
                  (click)="updateConfiguration()"
                  [disabled]="configLoading">
                  <span *ngIf="configLoading" class="spinner-border spinner-border-sm me-2"></span>
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       FILTROS
       ======================================== -->
  <div *ngIf="dashboardData" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title mb-3">
            <i class="fas fa-filter me-2"></i>
            Filtros de Análisis
          </h6>
          
          <div class="row align-items-end">
            <div class="col-md-3">
              <label for="startDate" class="form-label">Fecha Inicio</label>
              <input 
                type="date" 
                class="form-control" 
                id="startDate"
                [(ngModel)]="filters.startDate"
                (ngModelChange)="onDateFilterChange()"
                [disabled]="loading">
            </div>
            
            <div class="col-md-3">
              <label for="endDate" class="form-label">Fecha Fin</label>
              <input 
                type="date" 
                class="form-control" 
                id="endDate"
                [(ngModel)]="filters.endDate"
                (ngModelChange)="onDateFilterChange()"
                [disabled]="loading">
            </div>
            
            <!--<div class="col-md-3">
              <label for="accountPayment" class="form-label">Método de Pago</label>
              <input 
                type="text" 
                class="form-control" 
                id="accountPayment"
                placeholder="ID del Account Payment"
                [(ngModel)]="filters.account_payment"
                [disabled]="loading">
            </div>-->
            
            <div class="col-md-3">
              <div class="d-flex gap-2">
                <button 
                  type="button" 
                  class="btn btn-primary"
                  (click)="onFiltersChange()"
                  [disabled]="loading">
                  <i class="fas fa-search me-1"></i>
                  Aplicar
                </button>
                <button 
                  type="button" 
                  class="btn btn-outline-secondary"
                  (click)="clearFilters()"
                  [disabled]="loading">
                  <i class="fas fa-times me-1"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       MÉTRICAS PRINCIPALES (KPIs)
       ======================================== -->
  
  <!-- Estado de carga para métricas principales -->
  <div *ngIf="loading && !dashboardData" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body text-center py-4">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <h6 class="text-muted">Cargando métricas del dashboard...</h6>
          <p class="text-muted small mb-0">Esto puede tomar unos segundos</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Indicador de carga discreto -->
  <div *ngIf="loading && dashboardData" class="row mb-2">
    <div class="col-12">
      <div class="alert alert-info py-2 mb-0 d-flex align-items-center">
        <div class="spinner-border spinner-border-sm text-primary me-2" role="status">
          <span class="visually-hidden">Actualizando...</span>
        </div>
        <small class="mb-0">🔄 Actualizando métricas del dashboard...</small>
      </div>
    </div>
  </div>

  <!-- Métricas disponibles -->
  <div *ngIf="dashboardData" class="row mb-4" [class.opacity-75]="loading">
    <!-- Total Pagos -->
    <div class="col-md-3 mb-3">
      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <div class="flex-shrink-0">
              <div class="bg-primary rounded-circle p-3">
                <i class="fas fa-receipt text-white"></i>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="text-muted mb-1">Total Pagos</h6>
              <h4 class="mb-0">{{ formatNumber(dashboardData?.overview?.totalPayments) }}</h4>
            </div>
          </div>
          
          <!-- Información adicional -->
          <div class="text-center border-top pt-2 mt-2">
            <small class="text-muted d-block mb-1">En el Período</small>
            <span class="text-primary fw-bold">{{ filters.startDate || 'Hoy' }}</span>
            <span *ngIf="filters.endDate && filters.endDate !== filters.startDate" class="text-muted"> - {{ filters.endDate }}</span>
          </div>
          
          <!-- Espaciado adicional -->
          <div class="pt-3"></div>
        </div>
      </div>
    </div>
    
    <!-- Pagos Async -->
    <div class="col-md-3 mb-3">
      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <div class="flex-shrink-0">
              <div class="bg-success rounded-circle p-3">
                <i class="fas fa-sync-alt text-white"></i>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="text-muted mb-1">Pagos Async</h6>
              <h4 class="mb-0">{{ formatNumber(dashboardData?.overview?.asyncPayments) }}</h4>
            </div>
          </div>
          
          <!-- Porcentaje destacado -->
          <div class="text-center border-top pt-2 mt-2">
            <small class="text-muted d-block mb-1">Porcentaje del Total</small>
            <h3 class="text-success mb-0 fw-bold">
              {{ formatPercentage(dashboardData?.overview?.asyncPercentage) }}
            </h3>
          </div>
          
          <!-- Tiempo promedio de verificación -->
          <div class="text-center border-top pt-2 mt-2" *ngIf="performanceMetrics?.processing?.avgProcessingTimeMs">
            <small class="text-muted d-block mb-1">Tiempo Promedio Verificación</small>
            <strong class="text-info">{{ formatDuration(performanceMetrics?.processing?.avgProcessingTimeMs) }}</strong>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Total Trans BDV BP -->
    <div class="col-md-3 mb-3">
      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <div class="flex-shrink-0">
              <div class="bg-primary rounded-circle p-3">
                <i class="fas fa-chart-bar text-white"></i>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="text-muted mb-1">Total Trans BDV BP</h6>
              <h4 class="mb-0">{{ formatNumber(bdvTransactionIndicators?.totalTransactions?.totalTransactions || 0) }}</h4>
              <small class="text-primary">Generadas en el día</small>
            </div>
          </div>
          
          <!-- Información adicional -->
          <div class="text-center border-top pt-2 mt-2">
            <small class="text-muted d-block mb-1">En el Período</small>
            <span class="text-primary fw-bold">{{ filters.startDate || 'Hoy' }}</span>
            <span *ngIf="filters.endDate && filters.endDate !== filters.startDate" class="text-muted"> - {{ filters.endDate }}</span>
          </div>
          
          <!-- Espaciado adicional -->
          <div class="pt-3"></div>
        </div>
      </div>
    </div>
    
    <!-- BDV BP Async -->
    <div class="col-md-3 mb-3">
      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <div class="d-flex align-items-center mb-2">
            <div class="flex-shrink-0">
              <!-- Logo real del Banco de Venezuela -->
              <div class="rounded-circle p-2" style="width: 60px; height: 60px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);">
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Banco_de_Venezuela_logo.svg/512px-Banco_de_Venezuela_logo.svg.png" 
                  alt="Banco de Venezuela"
                  style="max-width: 45px; max-height: 45px; object-fit: contain; filter: brightness(0) invert(1);"
                  onerror="this.style.display='none'; this.parentElement.innerHTML='<div style=\'color: white; font-weight: bold; font-size: 12px; text-align: center;\'>BDV</div>';">
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="text-muted mb-1">BDV BP Async</h6>
              <h5 class="mb-0 text-primary">
                {{ formatNumber(bdvTransactionIndicators?.pendingVerification?.totalTransactions || 0) }}
              </h5>
            </div>
          </div>
          
          <!-- Porcentaje del Total -->
          <div class="text-center border-top pt-2 mt-2">
            <small class="text-muted d-block mb-1">Porcentaje del Total</small>
            <span class="text-success fw-bold">{{ (bdvTransactionIndicators?.pendingVerification?.percentage || '0.0') }}%</span>
          </div>
          
          <!-- Espaciado adicional -->
          <div class="pt-3"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       ESTADO DEL SISTEMA Y COLAS
       ======================================== -->
  
  <!-- Loading para sección de estado del sistema -->
  <div *ngIf="loading && !systemStatus" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body text-center py-4">
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <h6 class="text-muted">Cargando estado del sistema...</h6>
          <p class="text-muted small mb-0">Obteniendo datos de pagos async y colas</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Datos del sistema disponibles -->
  <div *ngIf="systemStatus || dashboardData" class="row mb-4" [class.opacity-75]="loading">
    <!-- Estados Async Success/Failed -->
    <div class="col-md-6 mb-3">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-check-circle me-2 text-success"></i>
            Pagos Async: Éxito vs Fallo
          </h6>
        </div>
        <div class="card-body">
          <!-- Estado de carga -->
          <div *ngIf="loading && !dashboardData" class="text-center py-4">
            <div class="spinner-border text-primary mb-2" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="text-muted mb-0">Cargando datos de pagos async...</p>
          </div>

          <!-- Datos disponibles -->
          <div *ngIf="dashboardData?.asyncSuccessFailureBreakdown" class="row">
            <div class="col-4 mb-3" *ngFor="let status of getStatusKeys(dashboardData.asyncSuccessFailureBreakdown)">
              <div class="text-center p-3 border rounded async-breakdown-card" 
                   [ngClass]="{
                     'border-success bg-light-success': status === 'SUCCESS',
                     'border-danger bg-light-danger': status === 'FAILED',
                     'border-warning bg-light-warning': status === 'PENDING'
                   }">
                <h4 class="mb-1" 
                    [ngClass]="{
                      'text-success': status === 'SUCCESS',
                      'text-danger': status === 'FAILED',
                      'text-warning': status === 'PENDING'
                    }">
                  {{ formatNumber(dashboardData.asyncSuccessFailureBreakdown[status]?.count) }}
                </h4>
                <p class="mb-1 fw-bold">
                  {{ status === 'SUCCESS' ? 'Exitosos' : 
                     status === 'FAILED' ? 'Fallidos' : 
                     status === 'PENDING' ? 'En Proceso' : status }}
                </p>
                <small class="fw-bold" [ngClass]="getPercentageColor(status)">
                  {{ calculateStatusPercentage(status) }}
                </small>
              </div>
            </div>
          </div>
          
          <!-- Sin datos disponibles -->
          <div *ngIf="!loading && !dashboardData?.asyncSuccessFailureBreakdown" class="text-center py-3">
            <i class="fas fa-info-circle text-muted mb-2 fs-4"></i>
            <p class="text-muted mb-1">No hay pagos async en este período</p>
            <small class="text-muted">
              Filtros: {{ filters.startDate || 'Sin fecha inicio' }} - {{ filters.endDate || 'Sin fecha fin' }}
              <span *ngIf="filters.account_payment"> | Account: {{ filters.account_payment }}</span>
            </small>
          </div>

          <!-- Error en carga -->
          <div *ngIf="!loading && error" class="text-center py-3">
            <i class="fas fa-exclamation-triangle text-warning mb-2 fs-4"></i>
            <p class="text-warning mb-0">Error cargando datos: {{ error }}</p>
            <button class="btn btn-sm btn-outline-primary mt-2" (click)="refreshDashboard()">
              <i class="fas fa-sync-alt me-1"></i>
              Reintentar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- BDV BP Async Estadísticas -->
    <div class="col-md-6 mb-3">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0 text-danger fw-bold">
            <i class="fas fa-university me-2 text-danger"></i>
            BDV BP Async Estadísticas
          </h6>
        </div>
        <div class="card-body">
          <!-- Estado de carga -->
          <div *ngIf="loading && !bdvTransactionIndicators" class="text-center py-4">
            <div class="spinner-border text-primary mb-2" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
            <p class="text-muted mb-0">Cargando datos de BDV...</p>
          </div>



            <!-- Datos BDV disponibles -->
            <div *ngIf="bdvTransactionIndicators?.verificationResults" class="row justify-content-center">
              <!-- Exitosos -->
              <div class="col-3 mb-3">
                <div class="text-center p-4 border rounded async-breakdown-card border-success bg-light-success">
                  <h5 class="mb-2 text-success">
                    {{ formatNumber(bdvTransactionIndicators.verificationResults.approved?.count || 0) }}
                  </h5>
                  <p class="mb-1 fw-bold">Exitosos</p>
                  <div class="text-success fw-bold">
                    {{ (bdvTransactionIndicators.verificationResults.approved?.percentage || 0) }}%
                  </div>
                </div>
              </div>
              
              <!-- En Proceso -->
              <div class="col-3 mb-3">
                <div class="text-center p-4 border rounded async-breakdown-card border-warning bg-light-warning">
                  <h5 class="mb-2 text-warning">
                    {{ formatNumber(bdvTransactionIndicators.verificationResults.inProcess?.count || 0) }}
                  </h5>
                  <p class="mb-1 fw-bold">En Proceso</p>
                  <div class="text-warning fw-bold">
                    {{ (bdvTransactionIndicators.verificationResults.inProcess?.percentage || 0) }}%
                  </div>
                </div>
              </div>
              
              <!-- Sin Respuesta Definitiva -->
              <div class="col-3 mb-3">
                <div class="text-center p-4 border rounded async-breakdown-card border-secondary" style="background-color: #FFF3E0; border-color: #FF9800 !important;">
                  <h5 class="mb-2" style="color: #FF9800;">
                    {{ formatNumber(bdvTransactionIndicators.verificationResults.nonResponse?.count || 0) }}
                  </h5>
                  <p class="mb-1 fw-bold">Sin Respuesta</p>
                  <div class="fw-bold" style="color: #FF9800;">
                    {{ (bdvTransactionIndicators.verificationResults.nonResponse?.percentage || 0) }}%
                  </div>
                </div>
              </div>
              
              <!-- Fallidas -->
              <div class="col-3 mb-3">
                <div class="text-center p-4 border rounded async-breakdown-card border-danger bg-light-danger">
                  <h5 class="mb-2 text-danger">
                    {{ formatNumber(bdvTransactionIndicators.verificationResults.rejected?.count || 0) }}
                  </h5>
                  <p class="mb-1 fw-bold">Fallidas</p>
                  <div class="text-danger fw-bold">
                    {{ (bdvTransactionIndicators.verificationResults.rejected?.percentage || 0) }}%
                  </div>
                </div>
              </div>
            </div>
          
          <!-- Sin datos disponibles -->
          <div *ngIf="!loading && !bdvTransactionIndicators?.verificationResults" class="text-center py-3">
            <i class="fas fa-info-circle text-muted mb-2 fs-4"></i>
            <p class="text-muted mb-1">No hay transacciones BDV en este período</p>
            <small class="text-muted">
              Filtros: {{ filters.startDate || 'Sin fecha inicio' }} - {{ filters.endDate || 'Sin fecha fin' }}
            </small>
          </div>

          <!-- Error en carga -->
          <div *ngIf="!loading && error" class="text-center py-3">
            <i class="fas fa-exclamation-triangle text-warning mb-2 fs-4"></i>
            <p class="text-muted mb-0">Error cargando datos de BDV</p>
          </div>
        </div>
      </div>
    </div>

    <!-- OCULTO: Estados Async Internos (temporalmente deshabilitado) -->
    <!--
    <div class="col-md-6 mb-3">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-cogs me-2 text-info"></i>
            Estados Async Internos
          </h6>
        </div>
        <div class="card-body">
          <div class="row" *ngIf="dashboardData?.asyncStatusBreakdown">
            <div class="col-6 mb-2" *ngFor="let status of getStatusKeys(dashboardData.asyncStatusBreakdown)">
              <div class="text-center p-2 border rounded async-status-card">
                <h6 class="mb-1">{{ formatNumber(dashboardData.asyncStatusBreakdown[status]?.count) }}</h6>
                <p class="mb-0 small fw-bold">{{ status }}</p>
                <small class="text-muted">
                  ${{ formatNumber(dashboardData.asyncStatusBreakdown[status]?.totalAmount) }}
                </small>
              </div>
            </div>
          </div>
          
          <div *ngIf="!dashboardData?.asyncStatusBreakdown || getStatusKeys(dashboardData.asyncStatusBreakdown).length === 0" class="text-center py-3">
            <span class="text-muted">No hay estados async específicos</span>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>

  <!-- Estado sin datos o error para sistema -->
  <div *ngIf="!loading && !systemStatus && !dashboardData && !error" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-body text-center py-4">
          <i class="fas fa-exclamation-triangle text-warning mb-3 fs-1"></i>
          <h6 class="text-muted">Sin datos del sistema</h6>
          <p class="text-muted small mb-3">No se pudieron cargar los datos del estado del sistema</p>
          <button class="btn btn-outline-primary btn-sm" (click)="refreshDashboard()">
            <i class="fas fa-sync-alt me-1"></i>
            Reintentar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       DISTRIBUCIÓN GENERAL POR TIPO (OCULTO TEMPORALMENTE)
       ======================================== -->
  <!--
  <div *ngIf="systemStatus" class="row mb-4">
    <div class="col-md-8">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-chart-pie me-2"></i>
            Distribución por Tipo de Transacción
          </h6>
        </div>
        <div class="card-body">
          <div class="row" *ngIf="dashboardData?.paymentsByStatus">
            <div class="col-md-4 mb-3" *ngFor="let status of getStatusKeys(dashboardData.paymentsByStatus)">
              <div class="text-center p-3 border rounded distribution-card">
                <h5 class="mb-1">{{ formatNumber(dashboardData.paymentsByStatus[status]?.count) }}</h5>
                <p class="mb-1 fw-bold">{{ status || 'Sin Definir' }}</p>
                <small class="text-muted">
                  ${{ formatNumber(dashboardData.paymentsByStatus[status]?.totalAmount) }}
                </small>
              </div>
            </div>
          </div>
          
          <div *ngIf="!dashboardData?.paymentsByStatus" class="text-center py-3">
            <span class="text-muted">No hay datos de distribución disponibles</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->
    
    <!-- OCULTO: Estado de Colas RabbitMQ (no disponible en tiempo real) -->
    <!--
    <div class="col-md-4">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-server me-2"></i>
            Estado de Colas
          </h6>
        </div>
        <div class="card-body">
          <div *ngIf="systemStatus?.queue">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold">Principal:</span>
              <span class="badge bg-primary">{{ systemStatus.queue.main?.messageCount || 0 }}</span>
            </div>
            
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold">Retry:</span>
              <span class="badge bg-warning">{{ systemStatus.queue.retry?.messageCount || 0 }}</span>
            </div>
            
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="fw-bold">DLQ:</span>
              <span class="badge bg-danger">{{ systemStatus.queue.dlq?.messageCount || 0 }}</span>
            </div>
            
            <hr>
            
            <div class="d-flex justify-content-between align-items-center">
              <span class="fw-bold">Workers:</span>
              <span class="badge bg-success">{{ systemStatus.queue.main?.consumerCount || 0 }}</span>
            </div>
          </div>
          
          <div *ngIf="!systemStatus?.queue" class="text-center py-3">
            <span class="text-muted">Datos de cola no disponibles</span>
          </div>
        </div>
      </div>
    </div>
    -->

  <!-- ========================================
       ANÁLISIS DE REINTENTOS (OCULTO TEMPORALMENTE)
       ======================================== -->
  <!--
  <div *ngIf="retryAnalysis" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-redo me-2"></i>
            Análisis de Reintentos
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">Distribución por Intento</h6>
              <div *ngFor="let item of retryAnalysis.retryDistribution" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>Intento {{ item._id }}:</span>
                  <span class="fw-bold">{{ formatNumber(item.count) }}</span>
                </div>
                <div class="progress mb-1" style="height: 6px;">
                  <div class="progress-bar" 
                       [style.width.%]="(item.count / retryAnalysis.summary?.totalAnalyzed) * 100">
                  </div>
                </div>
                <small class="text-muted">
                  Tiempo promedio: {{ formatDuration(item.avgResponseTime) }}
                </small>
              </div>
            </div>
            
            <div class="col-md-6">
              <h6 class="fw-bold mb-3">Performance por Tipo</h6>
              <div *ngFor="let item of retryAnalysis.durationByType" class="mb-2">
                <div class="d-flex justify-content-between">
                  <span>{{ item._id || 'N/A' }}:</span>
                  <span class="fw-bold">{{ formatNumber(item.count) }}</span>
                </div>
                <small class="text-muted d-block">
                  Duración promedio: {{ formatDuration(item.avgDuration) }}
                </small>
                <small class="text-muted">
                  Intentos promedio: {{ formatDecimal(item.avgAttempts) }}
                </small>
              </div>
            </div>
          </div>
          
          <div class="row mt-3">
            <div class="col-12">
              <div class="alert alert-info">
                <strong>Resumen del Análisis:</strong>
                Total analizado: {{ formatNumber(retryAnalysis.summary?.totalAnalyzed) }} | 
                Success rate general: {{ formatPercentage(retryAnalysis.summary?.overallSuccessRate) }} | 
                Intentos promedio antes de éxito: {{ formatDecimal(retryAnalysis.summary?.avgAttemptsBeforeSuccess) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  -->

  <!-- ========================================
       MÉTRICAS DE PERFORMANCE
       ======================================== -->
  <div *ngIf="performanceMetrics" class="row mb-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h6 class="mb-0">
            <i class="fas fa-chart-line me-2"></i>
            Métricas de Performance
          </h6>
        </div>
        <div class="card-body">
          <div class="row">
            <!-- Performance por Hora -->
            <div class="col-md-8">
              <h6 class="fw-bold mb-3">Performance por Hora del Día</h6>
              <div class="table-responsive">
                <table class="table table-sm table-striped">
                  <thead>
                    <tr>
                      <th>Hora</th>
                      <th>Cantidad</th>
                      <th>Tiempo Promedio</th>
                      <th>Éxitos</th>
                      <th>Success Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of performanceMetrics.performanceByHour">
                      <td>{{ item._id }}:00</td>
                      <td>{{ formatNumber(item.count) }}</td>
                      <td>{{ formatDuration(item.avgResponseTime) }}</td>
                      <td>{{ formatNumber(item.successCount) }}</td>
                      <td>
                        <span class="badge" 
                              [ngClass]="(item.successCount / item.count * 100) > 80 ? 'bg-success' : 'bg-warning'">
                          {{ formatPercentage((item.successCount / item.count) * 100) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <!-- Top Account Payments -->
            <div class="col-md-4">
              <h6 class="fw-bold mb-3">Top Métodos de Pago</h6>
              <div *ngFor="let item of performanceMetrics.topAccountPayments" class="mb-3">
                <div class="card border-0 shadow-sm">
                  <div class="card-body p-3">
                    <!-- Encabezado con banco y método de pago -->
                    <div class="d-flex align-items-center mb-2">
                      <div class="me-2">
                        <i class="fas fa-university text-primary"></i>
                      </div>
                      <div class="flex-grow-1">
                        <h6 class="card-title mb-0 text-truncate" [title]="item.display_name">
                          {{ item.display_name || 'N/A' }}
                        </h6>
                        <small class="text-muted">{{ item.display_subtitle || '' }}</small>
                      </div>
                      <div class="text-end">
                        <span *ngIf="item.successRate > 0" 
                              class="badge" 
                              [ngClass]="{
                                'bg-success': item.successRate > 60,
                                'bg-warning': item.successRate > 30 && item.successRate <= 60,
                                'bg-danger': item.successRate >= 0.01 && item.successRate <= 30
                              }">
                          {{ item.successRate }}%
                        </span>
                        <small *ngIf="item.successRate === 0" class="text-muted">
                          Sin éxitos
                        </small>
                      </div>
                    </div>
                    
                    <!-- Información específica del método de pago -->
                    <div class="mb-2 p-2 bg-light rounded">
                      <div class="row">
                        <div class="col-4">
                          <small class="text-muted d-block">{{ item.account_type }}</small>
                          <small class="fw-bold text-truncate d-block" [title]="item.account_info">
                            <i class="fas" 
                               [ngClass]="{
                                 'fa-phone': item.account_type === 'Teléfono',
                                 'fa-envelope': item.account_type === 'Email', 
                                 'fa-credit-card': item.account_type === 'Cuenta',
                                 'fa-tag': item.account_type === 'Identificador' || item.account_type === 'N/A'
                               }"
                               style="width: 12px;"></i>
                            {{ item.account_info }}
                          </small>
                        </div>
                        <div class="col-4 text-center">
                          <small class="text-muted d-block">Transacciones</small>
                          <strong class="text-primary">{{ formatNumber(item.count) }}</strong>
                        </div>
                        <div class="col-4 text-end">
                          <small class="text-muted d-block">Éxitos</small>
                          <small class="fw-bold text-success">{{ formatNumber(item.successCount) }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Mensaje cuando no hay datos -->
              <div *ngIf="!performanceMetrics?.topAccountPayments || performanceMetrics.topAccountPayments.length === 0" 
                   class="text-center py-4">
                <i class="fas fa-chart-bar text-muted mb-2 fs-4"></i>
                <p class="text-muted mb-0">No hay datos de métodos de pago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ========================================
       FOOTER CON INFORMACIÓN ADICIONAL
       ======================================== -->
  <div class="row">
    <div class="col-12">
      <div class="card bg-light">
        <div class="card-body">
          <div class="row text-center">
            <div class="col-md-3">
              <small class="text-muted">Última Actualización:</small>
              <br>
              <strong>{{ formatDateTime(dashboardData?.generatedAt) }}</strong>
            </div>
            <div class="col-md-3">
              <small class="text-muted">Configuración Actualizada:</small>
              <br>
              <strong>{{ formatDateTime(asyncConfig?.last_updated) }}</strong>
            </div>
            <div class="col-md-3">
              <small class="text-muted">Uptime Sistema:</small>
              <br>
              <strong>{{ formatDuration((systemStatus?.system_health?.uptime || 0) * 1000) }}</strong>
            </div>
            <div class="col-md-3">
              <small class="text-muted">Filtros Aplicados:</small>
              <br>
              <strong *ngIf="filters.startDate && filters.endDate">
                {{ filters.startDate }} - {{ filters.endDate }}
              </strong>
              <strong *ngIf="!filters.startDate || !filters.endDate">Sin filtros de fecha</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
